var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.6 0H15.6C17.5882 0 19.2 1.61177 19.2 3.6V15.6C19.2 17.5882 17.5882 19.2 15.6 19.2H3.6C1.61177 19.2 0 17.5882 0 15.6V3.6C0 1.61177 1.61177 0 3.6 0Z",
    fill: "#3DD598"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.43169 8.73455C5.96003 8.26897 5.20025 8.27389 4.73467 8.74554C4.26908 9.2172 4.274 9.97698 4.74566 10.4426L7.7948 13.4525C8.29643 13.9477 9.11479 13.9059 9.5634 13.3622L14.5143 7.36221C14.9361 6.85102 14.8636 6.09469 14.3524 5.67289C13.8412 5.25109 13.0849 5.32355 12.6631 5.83473L8.54719 10.8228L6.43169 8.73455Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/Check.b003fe67109dc6c5682fcff20c6cf513.svg";
export { ForwardRef as ReactComponent };